var SentryAdapter = /** @class */ (function () {
    function SentryAdapter(sentryInstance) {
        this.sentryInstance = sentryInstance;
    }
    SentryAdapter.prototype.reportError = function (error) {
        this.sentryInstance.captureException(error);
    };
    SentryAdapter.prototype.reportMessage = function (message) {
        this.sentryInstance.captureMessage(message);
    };
    return SentryAdapter;
}());
export { SentryAdapter };
//# sourceMappingURL=SentryAdapter.js.map